import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'components/ErrorBoundary';
import ItemPicker from 'components/ItemPicker';
import Modal from 'components/Modal';
import getFullUserName from 'utils/getFullUserName';
import { useFetchUsers } from 'actions/users';
import { jsx as _jsx } from "react/jsx-runtime";
function UserPickerModal(_ref) {
  var includeDeletedUsers = _ref.includeDeletedUsers,
    isSingleItemPicker = _ref.isSingleItemPicker,
    passedTitle = _ref.title,
    _ref$usersType = _ref.usersType,
    usersType = _ref$usersType === void 0 ? 'members' : _ref$usersType,
    teamId = _ref.teamId,
    assetId = _ref.assetId,
    eventSessionId = _ref.eventSessionId,
    users = _ref.users,
    filterForAdminRole = _ref.filterForAdminRole,
    _ref$extraItems = _ref.extraItems,
    extraItems = _ref$extraItems === void 0 ? [] : _ref$extraItems,
    _ref$allowSubmitWitho = _ref.allowSubmitWithoutChanges,
    allowSubmitWithoutChanges = _ref$allowSubmitWitho === void 0 ? false : _ref$allowSubmitWitho,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useFetchUsers = useFetchUsers({
      teamId: teamId,
      assetId: assetId,
      eventSessionId: eventSessionId,
      search: searchValue,
      includeDeletedUsers: includeDeletedUsers,
      filterForAdminRole: filterForAdminRole
    }),
    fetchedItems = _useFetchUsers.items,
    fetchNextPage = _useFetchUsers.fetchNextPage,
    hasNextPage = _useFetchUsers.hasNextPage,
    isLoading = _useFetchUsers.isLoading,
    isFetchingNextPage = _useFetchUsers.isFetchingNextPage;
  var items = React.useMemo(function () {
    return [].concat(_toConsumableArray(extraItems), _toConsumableArray(fetchedItems));
  }, [extraItems, fetchedItems]);
  var labels = {
    getSelectionStatus: function getSelectionStatus(count) {
      return usersType === 'individuals' ? t('individual_selection_status', {
        count: count
      }) : t('member_selection_status', {
        count: count
      });
    }
  };
  var defaultTitle = usersType === 'individuals' ? t('actions_select_individuals') : t('actions_select_users');
  var title = passedTitle || defaultTitle;
  return /*#__PURE__*/_jsx(Modal, {
    "aria-label": title,
    id: "manager-selector-modal",
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(ItemPicker, {
        title: title,
        labels: labels,
        items: items,
        defaultSelectedItems: users,
        hasNextPage: hasNextPage,
        onFetchNextPage: fetchNextPage,
        isFetchingNextPage: isFetchingNextPage,
        onSearchValueChange: setSearchValue,
        renderItemSubtitle: function renderItemSubtitle(item) {
          return item.displayName || getFullUserName(item);
        },
        isLoading: isLoading,
        onSubmit: onSubmit,
        onClose: onClose,
        isSingleItemPicker: isSingleItemPicker,
        allowSubmitWithoutChanges: allowSubmitWithoutChanges
      })
    })
  });
}
export default UserPickerModal;